import styled from 'styled-components';

const Action = styled.span`
  background: ${({ theme }) => theme.commons.button.secondary.background};
  color: ${({ theme }) => theme.commons.global.textPrimary};
  margin: ${({ theme }) => theme.spacing(0, 6)};
  align-items: center;
  display: flex;
  & > * {
    vertical-align: middle;
  }
`;

export default Action;
